import { Outlet } from "react-router-dom";

export default function HomePage() {
	return (
		<>
			<Outlet />
		</>
	);
}
